import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'custom-menu-item',
    templateUrl: './custom-menu-item.component.html',
    styleUrls: ['./custom-menu-item.component.scss', '../custom-menu.component.scss'],
    standalone: false
})
export class CustomMenuItemComponent {
  @Input() name: string;
  @Input() iconPath: string;
  @Input() disabled: boolean;
  @Output() executeEvent: EventEmitter<void> = new EventEmitter<void>();

  isHighlighted = false;

  executeItem(): void {
    if(!this.disabled) {
      this.executeEvent.emit();
    }
  }

  toggleHighlight(): void {
    if(!this.disabled){
      this.isHighlighted = !this.isHighlighted;
    }
  }
}
